import getLoginQRCode from './getLoginQRCode';
import qrLogin from './qrLogin';
import getVerifyCode from './getVerifyCode';
import bindLogin from './bindLogin';
export default {
  getLoginQRCode,
  qrLogin,
  getVerifyCode,
  bindLogin,
};


// WEBPACK FOOTER //
// ./src/api/wechat/index.ts